import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

domReady(() => {
  new Swiper('.swiper-carrousel-programs', {
    navigation: {
      nextEl: '.carrousel-program__arrows .swiper-button-next',
      prevEl: '.carrousel-program__arrows .swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
    spaceBetween: 20,
    slidesPerView: 1.3,
    breakpoints: {
      520: { slidesPerView: 2.25 },
      768: { slidesPerView: 2.75 },
      1280: { slidesPerView: 4.5 },
    },
  });
});
